// NewJobInvoiceDrawer's one write (finance-real, the user 2026-10-22): a draft invoice of the done or active jobs picked.
import type { UseMutationResult } from "@tanstack/react-query";
import { useCreateInvoice } from "../../hooks/useLineJobs";
import type { InvoiceJobsInput, JobInvoice } from "../../types";

export interface NewJobInvoiceDrawerModel {
  create: UseMutationResult<JobInvoice, Error, InvoiceJobsInput>;
}

export function useNewJobInvoiceDrawer(clientId: string): NewJobInvoiceDrawerModel {
  return { create: useCreateInvoice(clientId) };
}
